namespace RedBullMOBILE360.Web.Modules.Common.Helpers {
    export enum NotificationSource {
        TCC = 1,
        Manual = 2,
        AREEX = 3,
        InternalDeduction = 4
    }
    Serenity.Decorators.registerEnumType(NotificationSource, 'RedBullMOBILE360.Web.Modules.Common.Helpers.NotificationSource');
}
